import React, { useState, useEffect } from "react";
import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  // Slider,
  TextField,
  Typography,
  Paper,
  Tooltip,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

function getCurrentDateTime() {
  const now = new Date();

  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}`;
}

function Settings({ updateSettingsData }) {
  const [settingsData, setSettingsData] = useState({
    productGroup: "normal",
    ventilatorType: "sieninis",
    dateTime: getCurrentDateTime(),
  });

  const handleChange = (field) => (event) => {
    setSettingsData((prevSettingsData) => ({
      ...prevSettingsData,
      [field]: event.target.value,
    }));
  };

  useEffect(() => {
    updateSettingsData(settingsData);
  }, [settingsData, updateSettingsData]);

  return (
    <Box 
      sx={{
        p: 2,
        "@media (max-width: 600px)": {
          p: 1,
        },
      }}
    >
      <Paper elevation={2} sx={{ 
        p: 2,
        "@media (max-width: 600px)": {
          p: 1,
        },
      }}>
        <Typography variant="h6" gutterBottom>
          Rekuperacinės vėdinimo sistemos planavimo įrankis
        </Typography>

        <FormControl component="fieldset" margin="normal">
          <FormLabel component="legend">Prekių grupė</FormLabel>
          <RadioGroup
            row
            value={settingsData.productGroup}
            onChange={handleChange("productGroup")}
          >
            <FormControlLabel
              value="normal"
              control={<Radio />}
              label={
                <Box sx={{ display: "inline-flex", alignItems: "baseline", gap: 0.5 }}>
                  <span>Eco</span>
                  <Tooltip title="Eco - Vėdinimo įrenginiai su rotaciniais arba plokšteliniais šilumokaičiais" arrow enterTouchDelay={0} leaveTouchDelay={3000}>
                    <Box sx={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 28, height: 28, borderRadius: "50%", cursor: "pointer" }}>
                      <InfoOutlinedIcon sx={{ fontSize: 18, color: "action.active" }} />
                    </Box>
                  </Tooltip>
                </Box>
              }
            />
            <FormControlLabel
              value="premium"
              control={<Radio />}
              label={
                <Box sx={{ display: "inline-flex", alignItems: "baseline", gap: 0.5 }}>
                  <span>Premium</span>
                  <Tooltip title="Premium - Vėdinimo įrenginiai su entalpiniais šilumokaičiais" arrow enterTouchDelay={0} leaveTouchDelay={3000}>
                    <Box sx={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 28, height: 28, borderRadius: "50%", cursor: "pointer" }}>
                      <InfoOutlinedIcon sx={{ fontSize: 18, color: "action.active" }} />
                    </Box>
                  </Tooltip>
                </Box>
              }
            />
            <FormControlLabel
              value="premium_plus"
              control={<Radio />}
              label={
                <Box sx={{ display: "inline-flex", alignItems: "baseline", gap: 0.5 }}>
                  <span>Premium+</span>
                  <Tooltip title="Premium+ - Vėdinimo įrenginiai su entalpiniais šilumokaičiais ir pastovaus oro srauto palaikymo funkcija" arrow enterTouchDelay={0} leaveTouchDelay={3000}>
                    <Box sx={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 28, height: 28, borderRadius: "50%", cursor: "pointer" }}>
                      <InfoOutlinedIcon sx={{ fontSize: 18, color: "action.active" }} />
                    </Box>
                  </Tooltip>
                </Box>
              }
            />
          </RadioGroup>
        </FormControl>

        <FormControl component="fieldset" margin="normal">
          <FormLabel component="legend">Rekuperatoriaus versija</FormLabel>
          <RadioGroup
            row
            value={settingsData.ventilatorType}
            onChange={handleChange("ventilatorType")}
          >
            <FormControlLabel
              value="sieninis"
              control={<Radio />}
              label="Sieninis"
            />
            <FormControlLabel
              value="lubinis"
              control={<Radio />}
              label="Lubinis"
            />
          </RadioGroup>
        </FormControl>

        {/*<Typography gutterBottom>*/}
        {/*  Lubų aukštis: (cm): {ceilingHeight}*/}
        {/*</Typography>*/}
        {/*<Slider*/}
        {/*  value={ceilingHeight}*/}
        {/*  onChange={(e, newValue) => setCeilingHeight(newValue)}*/}
        {/*  valueLabelDisplay="auto"*/}
        {/*  step={1}*/}
        {/*  min={200}*/}
        {/*  max={500}*/}
        {/*  marks*/}
        {/*/>*/}

        <TextField
          label="Data / laikas"
          type="datetime-local"
          value={settingsData.dateTime}
          onChange={handleChange("dateTime")}
          InputLabelProps={{
            shrink: true,
          }}
          margin="normal"
        />
      </Paper>
    </Box>
  );
}

export default Settings;
